import { render, staticRenderFns } from "./ProductGroupProductsTable.vue?vue&type=template&id=40202e7f"
import script from "./ProductGroupProductsTable.vue?vue&type=script&lang=js"
export * from "./ProductGroupProductsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports